export default {
    signin: {
      pageName: "Адміністратор",
      title: "Авторизація",
      userForm: {
        username: {
          placeholder: "Користувач"
        },
        password: {
          placeholder: "Пароль"
        },
        language: {
          placeholder: "Мова"
        },
        connection: {
          placeholder: "Підключення"
        },
        signin: "Вхід"
      },
      alert: "Для входу потрібно ввести ім'я користувача та пароль",
      userRules: {
        username: {
          required: "Необхідно ввести ім'я користувача",
          min: "Ім'я користувача повинно бути не менше 4 символів",
          max: "Ім'я користувача повинно бути не більше 24 символів"
        },
        password: {
          required: "Необхідно ввести пароль",
          min: "Довжина пароля повинна бути не менше 4 символів",
          max: "Довжина пароля повинна бути не більше 24 символів"
        },
        language: {
          required: "Необхідно вибрати мову"
        },
        connection: {
          required: "Необхідно вибрати підключення"
        }
      }
    }
  };
  